"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _utilityClassNames = require("@emcm-ui/utility-class-names");

var _utilityClassNames2 = _interopRequireDefault(_utilityClassNames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Loader = function Loader(_ref) {
  var label = _ref.label;

  var getClassName = (0, _utilityClassNames2.default)(Loader.displayName);

  return _react2.default.createElement(
    "div",
    { className: getClassName() },
    _react2.default.createElement("div", {
      className: getClassName({
        descendantName: "spinner"
      })
    }),
    _react2.default.createElement(
      "div",
      {
        className: getClassName({
          descendantName: "label",
          utilities: "hiddenVisually"
        })
      },
      label
    )
  );
};

Loader.displayName = "Loader";

Loader.propTypes = {
  /**
   * label: spinning label when in loading state.
   */
  label: _propTypes2.default.string.isRequired
};

Loader.defaultProps = {
  label: "loading"
};

exports.default = Loader;